import React from "react";
import "./tempPage.css";

function TempPage() {
  return <div className="temppage-wrapper"></div>;
}

export default TempPage;
